import { ChangeEvent, forwardRef } from 'react'
import { Input } from '@wellesley/ui'
import ClearField from 'user/components/ClearField'

type LocationInputProps = {
  value: string
  anchorRef: (node: HTMLDivElement | null) => void
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onFocus: () => void
  onClear: () => void
}

const LocationInput = forwardRef<HTMLInputElement, LocationInputProps>(
  ({ value, anchorRef, onChange, onFocus, onClear }, ref) => (
    <div ref={anchorRef} className="relative flex-1">
      <Input
        ref={ref}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        placeholder="Add location"
        data-testid="location-input"
        className="h-m w-full pr-9 outline-none ring-0 focus-visible:ring-0 focus-visible:ring-offset-0"
      />
      {value && (
        <ClearField
          onClick={onClear}
          className="top-xxxs absolute right-[5px]"
        />
      )}
    </div>
  ),
)

LocationInput.displayName = 'LocationInput'

export default LocationInput
